import type { Translation } from '../types.ts';
import type en from '../en/submissions.ts';

export default {
    status: {
        sent: 'Verzonden',
        failed: 'Mislukt',
        quarantined: 'In quarantaine',
        spam: 'Spam',
    },
    blockReason: {
        honeypot: 'botval',
        tooFast: 'te snel verzonden',
        replayed: 'dubbel verzonden',
        expired: 'formulier verlopen',
        invalid: 'ongeldige formuliergegevens',
        csrf: 'sessie klopt niet',
    },
    list: {
        title: 'Formulierinzendingen',
        allForms: 'Alle formulieren',
        anyStatus: 'Elke status',
        quarantinedReview: 'In quarantaine (beoordelen)',
        search: 'Zoeken op e-mail of naam van de afzender…',
        sender: 'Afzender',
        blocked: 'Tegengehouden in de afgelopen {days} dagen, voordat ze in deze lijst kwamen: {total} ({parts})',
        blockedPart: '{reason} {n}',
        empty: 'Geen inzendingen gevonden.',
        form: 'Formulier',
        submitted: 'Verzonden op',
        unread: 'Ongelezen',
        page: 'Pagina {page} van {pages}',
        count: 'geen inzendingen | {n} inzending | {n} inzendingen',
    },
    detail: {
        title: 'Inzending #{id}',
        sending: 'Verzenden…',
        approve: 'Goedkeuren en verzenden',
        rejecting: 'Afwijzen…',
        reject: 'Afwijzen als spam',
        resending: 'Opnieuw verzenden…',
        resend: 'Opnieuw verzenden',
        markUnread: 'Markeren als ongelezen',
        markedUnread: 'Gemarkeerd als ongelezen',
        confirmDelete: 'Deze inzending verwijderen? Dit kan niet ongedaan worden gemaakt.',
        sentOk: 'Inzending verzonden.',
        held: 'Vastgehouden ter beoordeling: mogelijk spam (score {score})',
        notEmailed: 'Dit bericht is {not} gemaild. Keur het goed om het te verzenden, of wijs het af om het als spam te laten staan.',
        notEmailedNot: 'niet',
        form: 'Formulier',
        submitted: 'Verzonden op',
        to: 'Aan',
        subject: 'Onderwerp',
        noFields: 'Geen veldgegevens.',
        attachments: 'Bijlagen ({n})',
        removed: 'verwijderd {date} (bewaartermijn verlopen)',
        downloading: 'Downloaden…',
        notAvailable: 'Niet beschikbaar',
        showFull: '{name} op volle grootte tonen',
    },
} satisfies Translation<typeof en>;
